import { ApplicationRef, Injectable, ComponentRef } from '@angular/core';
import { createComponent, EnvironmentInjector } from '@angular/core';
import { NotificationComponent } from '../../components/notification/notification.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private appRef: ApplicationRef,
    private injector: EnvironmentInjector
  ) { }

  public count: number = 0;

  showNotification(
    title: string,
    message: string,
    type: 'info' | 'error' | 'success' | 'warning',
    duration: number = 3000,
    targetId: string = 'notification-container'
  ) {
    const notificationRef = this.createNotificationComponent(title, message, type);

    // Trova il contenitore target
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Appendi il componente al contenitore
      targetElement.appendChild(notificationRef.location.nativeElement);
    } else {
      console.error(`Elemento con ID "${targetId}" non trovato nel DOM.`);
      return;
    }

    // Mostra la notifica
    notificationRef.instance.show();

    notificationRef.instance.onClose.subscribe(() => {
      this.removeNotification(notificationRef, targetElement);
    })

    // Dopo la durata specificata, nascondi e rimuovi il componente
    setTimeout(() => {
      notificationRef.instance.hide();

      this.removeNotification(notificationRef, targetElement);

    }, duration);
  }

  private createNotificationComponent(
    title: string,
    message: string,
    type: 'info' | 'error' | 'success' | 'warning'
  ): ComponentRef<NotificationComponent> {
    const notificationRef = createComponent(NotificationComponent, {
      environmentInjector: this.injector,
    });

    let color: string;
    let icon: string;

    this.count++;

    switch (type) {
      case 'error':
        color = 'danger';
        icon = 'exclamation-diamond-fill';
        break;
      case 'success':
        color = 'success';
        icon = 'patch-check-fill';
        break;
      case 'warning':
        color = 'warning';
        icon = 'exclamation-triangle-fill';
        break;
      default:
        color = 'info';
        icon = 'question-octagon-fill';
        break;
    }

    notificationRef.instance.title = title;
    notificationRef.instance.message = message;
    notificationRef.instance.icon = icon;
    notificationRef.instance.color = color;
    notificationRef.instance.id = `notification-component-${this.count}`;

    this.appRef.attachView(notificationRef.hostView);

    return notificationRef;
  }

  private removeNotification(
    notificationRef: ComponentRef<NotificationComponent>,
    parentElement: HTMLElement
  ) {
    const domElem = notificationRef.location.nativeElement;

    // Controlla se l'elemento è ancora presente nel genitore
    if (parentElement.contains(domElem)) {
      parentElement.removeChild(domElem);
    } else {
      console.warn('Elemento non trovato nel genitore.');
    }

    // Stacca la vista e distruggi il componente
    this.appRef.detachView(notificationRef.hostView);
    notificationRef.destroy();
  }
}
